module.exports = __webpack_public_path__ + "img/print_fingerprint@2x.86928af.webp";